module.exports = __webpack_public_path__ + "static/favicon-901ed92a1b0c82d98693ce2438a42e1e.ico";